import {
  Text,
  Flex,
  Button,
  Image,
  Stack,
  VStack,
  useToast,
} from '@chakra-ui/react';
import { SubmitHandler, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Link, useHistory } from 'react-router-dom';

import logoWWA from '../../assets/wwa-branco.png';
import logoPraktika from '../../assets/praktika-branco.png';
import { Input } from '../../components/Form/Input';
import { api } from '../../services/api';

type ForgotPasswordData = {
  email: string;
}

const EmailValidation = async (value: string | undefined): Promise<boolean> => {
  if (value) {
    const { data } = await api.get(`/users/valid`, {
      params: {
        field: 'email',
        value,
      }
    })

    return data
  }

  return true
}

const signUpFormSchema = yup.object().shape({
  email: yup.string()
    .email('Necessário informar um e-mail valido')
    .required('E-mail obrigatório')
    .test(
      'email-not-exists',
      'E-mail informado não localizado em nossos cadastros',
      async (value) => (
        await EmailValidation(value)
      )
    ),
})

export function ForgotPassword() {
  const { register, handleSubmit, formState } = useForm({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: yupResolver(signUpFormSchema)
  })

  const { errors } = formState;

  const history = useHistory()
  const toast = useToast()

  const handleForgot: SubmitHandler<ForgotPasswordData> = async (values) => {
    try {
      await api.post('/password/forgot', values);

      toast({
        title: "E-mail enviado",
        description: "Foi enviado e-mail com as instruções para recuperação da senha.",
        status: "success",
        duration: 3000, // 3 seconds,
        isClosable: true,
        position: "top-right",
      })

      history.push('/')
    } catch (err: any) {
      toast({
        title: "Opa...",
        description: "Ocorreu uma instabilidade. Por favor tente novamente mais tarde.",
        status: "error",
        duration: 3000, // 3 seconds,
        isClosable: true,
        position: "top-right",
      })
    }
  }

  return (
    <Flex
      w="100vw"
      h="100vh"
      maxW="100vw"
      maxH="100vh"
      justify="center"
      alignItems="center"
      css={{
        'background-image': 'linear-gradient(135deg, #1e2f50 0%, #3e72ad 99%)'
      }}
    >
      <Flex
        flexDir="column"
        w="100%"
        alignItems="center"
        justifyContent="center"
        p="8"
      >
        <Image
          src={logoPraktika}
          alt="PrAktiKa"
          w="400px"
        />

        <Flex
          as="form"
          w="100%"
          maxWidth={400}
          p="8"
          alignItems="center"
          bg="#ffffff10"
          backdropBlur="10px"
          zIndex="1"
          borderRadius={8}
          flexDir="column"
          onSubmit={handleSubmit(handleForgot)}
        >
          <Text fontSize="4xl" mb="10">Recuperar Senha</Text>

          <Stack w="100%" spacing="4">
            <Input
              nameInput="email"
              type="email"
              label="E-mail"
              error={errors.email}
              {...register('email')}
            />
          </Stack>

          <Button
            type="submit"
            w="100%"
            minH="12"
            mt="6"
            bg="#50b683"
            size="lg"
            isLoading={formState.isSubmitting}
            _hover={{
              backgroundColor: "#46a174"
            }}
          >
            Recuperar
          </Button>

          <Link
            to="/"
          >
            <Text
              mt="8"
              fontSize="sm"
              bgColor="transparent"
              _hover={{
                bgColor: "transparent",
                color: "#50b683"
              }}
            >
              Voltar
            </Text>
          </Link>
        </Flex>

        <VStack
          mt="4"
        >
          <Text>um serviço oferecido por</Text>
          <Image
            src={logoWWA}
            alt="Wunderwelt-A"
            w="200px"
          />
        </VStack>
      </Flex>
    </Flex>
  );
}
